import { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { ArrowRight, Play } from 'lucide-react';

import { PrimaryCTA } from '../components/PrimaryCTA';
import { SecondaryCTA } from '../components/SecondaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';
import { MARKETING_APP_ENTRY_HREF } from '../marketingContent';

import setupVideoUrl from '@/videos/Instructor account creation 1_edit_small.mp4';
import styles from './FacultyHeroSection.module.css';

export function FacultyHeroSection() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <SectionWrapper background="white" data-testid="faculty-section-hero">
      <div className={styles.layout}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>FOR FACULTY</p>
          <h1 className={styles.title}>A complete modern course in 2 minutes.</h1>
          <p className={styles.subhead}>
            Pick a pre-built Kudu course in your subject. Add your roster.
            Start teaching. Textbook. AI tutoring. Homework. Polling —
            included. Setup takes about as long as making coffee.
          </p>

          <div className={styles.actions}>
            <PrimaryCTA
              href={MARKETING_APP_ENTRY_HREF}
              icon={<ArrowRight aria-hidden="true" size={16} />}
              label="Start a free course"
            />
            <SecondaryCTA
              icon={<Play aria-hidden="true" size={16} />}
              label="Watch the 2-minute setup"
              onClick={() => setIsVideoOpen(true)}
            />
          </div>

          <p className={styles.caption}>
            Free for instructors. $25 per student per semester. No credit card to try.
          </p>
        </div>

        <div aria-hidden="true" className={styles.media} id="setup-demo">
          <div className={styles.mediaFrame}>
            <div className={styles.browserChrome}>
              <span className={styles.chromeDot} />
              <span className={styles.chromeDot} />
              <span className={styles.chromeDot} />
              <span className={styles.chromeLabel}>kudu.com/app/create</span>
            </div>
            {/* Decorative, silent preview loop; the dialog below offers the
                full video with controls. */}
            <div className={styles.mediaViewport}>
              <video
                autoPlay
                className={styles.mediaVideo}
                loop
                muted
                playsInline
                src={setupVideoUrl}
                tabIndex={-1}
              />
            </div>
          </div>
        </div>
      </div>

      <Dialog.Root onOpenChange={setIsVideoOpen} open={isVideoOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className={styles.videoOverlay} />
          <Dialog.Content className={styles.videoContent}>
            <Dialog.Title className={styles.videoTitle}>
              2-minute setup video
            </Dialog.Title>
            <Dialog.Description className={styles.videoDescription}>
              Watch an instructor account get created and a course set up, start
              to finish, in about two minutes.
            </Dialog.Description>
            <video
              autoPlay
              className={styles.videoPlayer}
              controls
              playsInline
              src={setupVideoUrl}
            />
            <div className={styles.videoActions}>
              <SecondaryCTA label="Close" onClick={() => setIsVideoOpen(false)} />
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </SectionWrapper>
  );
}
